<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        fieldValue: {
            get() {
                if ((this.field.options?.options ?? []).length > 0) {
                    return this.filteredFieldValue(Array.from(this.value ?? []));
                }

                return this.value;
            },
            set(field) {
                this.$emit('input', this.filteredFieldValue(field));
            },
        },
    },
    methods: {
        filteredFieldValue(field) {
            return field.filter(value => this.field.options?.options?.find(option => option === value));
        },
    },
};
</script>

<template>
    <b-form-checkbox-group
        v-model="fieldValue"
        :options="field.options?.options"
        stacked
    />
</template>

<style
    scoped
    lang="scss"
>

</style>
